import React, { Component } from 'react';
import get from 'lodash/get';

import 'bootstrap/dist/css/bootstrap.css'
import '../scss/app.scss';
import Router from './Router';
import { PRIMARY_GRADIENT_ONE } from '../constants/app';
import store from './store';
import { appLogout } from '../libs/utils';

class App extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      loaded: false

    } // END state

  } // END constructor

  componentDidMount() {
    const { loaded } = this.state;
    if (!loaded) setTimeout(() => this.setState({ loaded: true, loading: false }), 500);
    window.addEventListener('load', () => console.log("ON WINDOW LOAD"));

    const { access_token } = get(store.getState(), 'account');
    const validateSession = sessionStorage.getItem('session');
    
  } // END componentDidMount

  render() {
    const { loaded } = this.state;
    return (
      <div id="porcobrar">
        {!loaded && <div className={`load${this.state.loading ? '' : ' loaded'}`}>
          <div className='load__icon-wrap'>
            <svg className='load__icon'>
              <path fill={ PRIMARY_GRADIENT_ONE } d='M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z'/>
            </svg>
          </div>
        </div>}
        <div>
          <Router/>
        </div>
      </div>
    );

  } // END render

} // END App

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js